import { render, staticRenderFns } from "./tarif-chambre.html?vue&type=template&id=36555a19&scoped=true&external"
import script from "./tarif-chambre.js?vue&type=script&lang=js&external"
export * from "./tarif-chambre.js?vue&type=script&lang=js&external"
import style0 from "./tarif-chambre.scss?vue&type=style&index=0&id=36555a19&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36555a19",
  null
  
)

export default component.exports